import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CheckIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.99994C17.5231 1.99994 22 6.4768 22 11.9999C22 17.5231 17.5231 21.9999 12 21.9999C6.47686 21.9999 2 17.5231 2 11.9999C2 6.4768 6.47686 1.99994 12 1.99994ZM12 2.99994C7.02914 2.99994 3 7.02908 3 11.9999C3 16.9708 7.02914 20.9999 12 20.9999C16.9709 20.9999 21 16.9708 21 11.9999C21 7.02908 16.9709 2.99994 12 2.99994ZM8.13842 11.6699C8.32298 11.4877 8.6222 11.4877 8.80676 11.6699L11.0148 13.8505L15.1718 9.15931C15.3436 8.96533 15.6422 8.94569 15.8386 9.11544C16.035 9.28518 16.0549 9.58003 15.883 9.774L11.3934 14.8406C11.2134 15.0437 10.8969 15.0541 10.7036 14.8632L8.13842 12.33C7.95386 12.1477 7.95386 11.8522 8.13842 11.6699Z'
      />
    </svg>
  );
};
